export enum Category {
  Audiometry = 'Odyometri',
  Pulmonary = 'Solunum Fonksiyon Testi (SFT)',
}
